import { createContext } from "react";

const FormFieldNamesContext = createContext({registerFormFieldName: (_any:any) => {}, unregisterFormFieldName: (_any:any) => {}});

export default FormFieldNamesContext;